import { render, staticRenderFns } from "./StTextImage.vue?vue&type=template&id=2504ad32"
import script from "./StTextImage.vue?vue&type=script&lang=ts"
export * from "./StTextImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports